import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";

// Import Background Image
import Background from "../../assets/images/service-icon-bg.png";
import Icon1 from "../../assets/why-us-1.svg";
import Icon2 from "../../assets/why-us-2.svg";
import Icon3 from "../../assets/why-us-3.svg";
import Icon4 from "../../assets/why-us-4.svg";

export default class WhyUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        {
          img: Icon1,
          title: "Quality matters",
          description:
            "Choosing Solar Storm means investing in high-performance, durable solar panels you can trust. Make the strategic move to solar with confidence—our guarantee ensures you're powered for the long run.",
        },
        {
          img: Icon2,
          title: "Affordable Solar Solutions",
          description:
            "We’re passionate about the transformative power of solar energy. That’s why we offer competitive pricing—making solar accessible and practical for everyone. Start saving on your utility bills today.",
        },
        {
          img: Icon3,
          title: "Create a Positive Impact on the Planet",
          description:
            " Harness the power of solar energy to generate clean, renewable electricity. By reducing your carbon footprint and cutting pollution from fossil fuels, you’re contributing to a healthier environment and a sustainable future.",
        },
        {
          img: Icon4,
          title: "Exceptional Customer Service",
          description:
            "Solar Storm has been helping Uttar Pradesh embrace solar energy long before it became popular. We prioritize education and make the transition to solar simple and stress-free.",
        },
      ],
    };
  }

  render() {
    const renderItems = this.state.items.map((item, index) => (
      <Col md={6} key={index}>
        <div className="card service-box text-center p-4">
          <div
            className="service-icon-bg mx-auto avatar-xxl p-4"
            style={{ backgroundImage: `url(${Background})` }}
          >
            <div className="service-box-icon justify-content-center">
              <img src={item.img} alt="" className="img-fluid d-block" />
            </div>
          </div>
          <h3 className="service-title mt-4 mb-3 f-18">{item.title}</h3>
          <p className="service-subtitle f-15 mb-0">{item.description}</p>
        </div>
      </Col>
    ));

    return (
      <React.Fragment>
        <section className="section bg-light" id="why-us">
          <Container>
            <Row className="justify-content-center">
              <Col lg={7}>
                <div className="text-center mb-5">
                  <h2 className="service-title f-24">Why us</h2>
                  <h3
                    className="hero-1-title fw-normal"
                    style={{ color: "#2077b8" }}
                  >
                    Reasons to Go Solar with Solar Storm
                  </h3>
                </div>
              </Col>
            </Row>
            <Row>{renderItems}</Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
